<template>
    <div class="game-header">
        <span class="game">{{ 'productName' | translate }} - </span>
        <span >{{'round' | translate}}</span>
        <span class="game-round">{{gameStatus.displayRoundNumber}}</span>
        <span v-if="gameStatus.roundInProgress">{{ 'in_progress' | translate}}</span>
        <span v-if="gameStatus.countdown">{{ 'starts_in' | translate}}</span>
        <span v-if="gameStatus.countdown" class="game-countdown">{{ moment.utc(gameStatus.startingIn*1000).format('m:ss') }}</span>
    </div>
</template>

<script>

    import {GameSvc} from '../../../services/game.service';
    import {translate} from '../../../filters/translate';
    import moment from 'moment';

    export default {
        name: 'GameHeader',
        filters: {
            translate,
        },
        data() {
            return {
                gameStatus:  GameSvc.getGameSvc().gameInfo,
                moment : moment
            }
        }
    };

</script>

<style  lang="scss">
    @import '../../../assets/style/terminal/variables';
    @import '../../../assets/style/terminal/header';

    .game {
        color:#EEC013;
        font-weight: bold;
        font-size: 1em;
    }

    .game-round,
    .game-countdown{
        color:#fff;
        font-weight: bold;
        font-size: 1em;
    }
</style>


// WEBPACK FOOTER //
// GameHeader.vue?0ddfa881